import { Page, PageTitle } from '../../../components';
import { ContractManagementList } from './ContractManagementList';

export const ContractManagment = () => {
  return (
    <Page title="Contract Management">
      <PageTitle title="Contract Management" />
      <ContractManagementList />
    </Page>
  );
};
